<template>
  <div class="flex flex-col gap-6">
    <div>
      <router-link
        :to="{ name: 'Best' }"
        class="flex items-center gap-2 hover:brightness-125 active:brightness-75 transition-all"
      >
        <i v-html="$icons.chevron_left"></i>
        <span> Voltar </span>
      </router-link>
    </div>
    <div class="flex flex-col gap-6">
      <div class="flex flex-col pt-12">
        <h2 class="text-3xl font-bold text-gray-50 md:text-5xl">Ranking</h2>
        <span class="pt-4 text-sm md:text-base"> Progresso atualizado em DD/MM/AAAA. </span>
      </div>
      <div class="flex flex-col xl:flex-row items-center justify-center gap-6">
        <BestRankingPodiumComponent :top_10="top_10" />
        <BestRankingTableComponent :top_10="top_10" :user_data="user_data" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../core/http/axios";
import routes from "../../../core/config/api-ontick.routes";
import { mapGetters } from "vuex";
import otp_badge from "../assets/otp_badge";
import PnlIndicatorComponent from "../components/pnl-indicator.component.vue";
import BestRankingPodiumComponent from "../components/best-ranking-podium.component.vue";
import BestRankingTableComponent from "../components/best-ranking-table.component.vue";

export default {
  components: {
    PnlIndicatorComponent,
    BestRankingPodiumComponent,
    BestRankingTableComponent,
  },

  data() {
    return {
      otp_badge,
      top_10: [],
      user_data: [],
      interval: null,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    async getRanking() {
      try {
        const { account_id } = this.getSelectedAccount;
        const { data } = await api.get(routes.GET_BESTS_RANKING, {
          params: {
            account_id,
            // ranking_case: 2,
          },
        });
        const { top_10, user_data, user_position } = data;
        if (top_10) {
          this.top_10 = top_10.map(({ pnl, user_code, trades }, index) => {
            return {
              pos: index + 1,
              result: pnl,
              code: user_code,
              bests: trades,
              is_user: this.getSelectedAccount.user_code == user_code,
            };
          });
          if (this.top_10.length < 10) {
            const empty_count = 10 - this.top_10.length;
            for (let i = 0; i < empty_count; i++) {
              this.top_10.push({ pos: "", result: "", code: "", bests: "" });
            }
          }
        } else {
          this.top_10 = [];
        }
        if (user_data) {
          this.user_data = user_data?.map(({ position, pnl, user_code, trades }, index) => {
            const position_enum = {
              top: 0,
              middle: 1,
              bottom: 2,
            };
            return {
              pos: position,
              result: pnl,
              code: user_code,
              bests: trades,
              is_user: position_enum[user_position] == index,
            };
          });
        } else {
          this.user_data = [];
        }
      } catch (err) {
        console.error(err);
      }
    },
  },

  async mounted() {
    await this.getRanking();
    this.interval = setInterval(async () => {
      await this.getRanking();
    }, 60000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped></style>
